import client, { PRIVATE_CLIENT } from '../../services/client';
import sessionStore from '../../store/session';

export const getCallLogAction = async (business_id) => {
    console.log('getCallLogAction', business_id);
    const response = await client.get('telephony/calls/', PRIVATE_CLIENT, null, {
        number: business_id,
    });

    sessionStore.setCalls(response);
};

// get next page of call log

export const getNextPageCallLogAction = async (business_id, page) => {
    const response = await client.get('v2/crm_calls/', PRIVATE_CLIENT, null, {
        business_id: business_id,
        page: page,
    });

    sessionStore.setNextPaginatedCalls(response);
};

export const getVoiceMessageAction = async (business_id) => {
    const response = await client.get('voice_messages/', PRIVATE_CLIENT, null, {
        business_id: business_id,
    });

    sessionStore.setVoiceMessages(response);
};

export const getVoiceMessageNextPageAction = async (business_id, page) => {
    const response = await client.get('voice_messages/', PRIVATE_CLIENT, null, {
        business_id: business_id,
        page: page,
    });

    sessionStore.setNextPaginatedVoiceMessages(response);
};
